import { render, staticRenderFns } from "./SupportRequests.vue?vue&type=template&id=330be738&"
import script from "./SupportRequests.vue?vue&type=script&lang=js&"
export * from "./SupportRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports